export default __webpack_public_path__ + "static/offices-world-map-70bd3cd6a3f607d4f2853a88b5137fa9.png";